import React, { useState } from "react";
import { AnimatedHeaderSidHome} from "../../../Modal/styledGlobalModal";


import { CiFilter, CiMaximize1 } from "react-icons/ci";
import { Input, Spin, Tooltip } from "antd";
import { ClearOutlined, LoadingOutlined } from "@ant-design/icons";
import { IoSearch } from "react-icons/io5";

export function HeaderSideHom({ isVisible, onSearch, onSearchSituacao, loading }) {

  const [isReduced, setIsReduced] = useState(false);
  const [selectedTipo, setSelectedTipo] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [inputValueSearch, setInputValueSearch] = useState("");

  const handleInputChange = (e) => {
    setInputValueSearch(e.target.value);
  }
  
  const handleRadioChange = (event) => {
    const value = event.target.value;
    if (selectedTipo === value) {
      setSelectedTipo(null);
    } else {
      setSelectedTipo(value);
    }
  };

  const clearFilters = () => {
    setInputValueSearch('');
    setSelectedTipo('');
    setSelectedStatus('');
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSearch();
    }
  };

    const handleSearch = () => {
      console.log("Chamando onSearch com:", {
        inputValueSearch,
        selectedStatus,
        selectedTipo,
        loading,
      });
    
      onSearch(inputValueSearch, selectedStatus, selectedTipo, loading);
    };

  return (

    <AnimatedHeaderSidHome reduced={isReduced} isVisible={isVisible}>
      <div className="hamburger">
        {isReduced === true ? (
          <div className="btn-hamburger" onClick={() => setIsReduced(!isReduced)}>
            <span className="font-icon">
              <CiMaximize1 />
            </span>
          </div>
        ) : (
          <div className="btn-hamburger" onClick={() => setIsReduced(!isReduced)}>
            <span className="font-icon">
              <CiFilter />
            </span>
          </div>
        )}
      </div>


      <div className="content">
        <span>Buscar por: </span>

        <div className="padding-5">
          <div className="margin-right-5">
            <Input
              type="text"
              placeholder="OS, Municípios e Cliente"
              value={inputValueSearch}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              disabled={loading}
            />
          </div>
        </div>


        <div className="text-align-left padding-5">
          <div className="header-flex text-align-left top-20">
            <ul>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="TODOS"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "TODOS"}
                />
                Todas as áreas
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="PARALEGAL"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "PARALEGAL"}
                />
                Paralegal
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="SERVICOS_CONTABIL"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "SERVICOS_CONTABIL"}
                />
                Contábil
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="VENDAS"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "VENDAS"}
                />
                Vendas
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="SERVICOS"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "SERVICOS"}
                />
                Serviços
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="SERVICOS_FISCAL"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "SERVICOS_FISCAL"}
                />
                Fiscal
              </li>
              <li>
                <input
                  type="radio"
                  name="area"
                  value="SERVICOS_DP"
                  onChange={handleRadioChange}
                  checked={selectedTipo === "SERVICOS_DP"}
                />
                DP
              </li>
            </ul>
          </div>
        </div>

        <div className="text-align-left padding-8 header-flex" >
          <Tooltip title="Limpar filtro">
            <div
              className="sty-btn bg-white margin-right-5" /*ESSAS CLASSE: sty-btn bg-white ESTÃO DENTRO DE bgGlobal.css pois ela é padrão de botoes*/
              onClick={() => clearFilters()}
              style={{ cursor: loading ? "not-allowed" : "pointer" }}
            >
              <ClearOutlined />
            </div>
          </Tooltip>

          <Tooltip title="Pesquisar">
            <div
              className={`sty-btn bg-padrao ${loading ? "bg-white cursor-not-allowed" : "cursor-pointer"}`}
              onClick={() => {handleSearch()}}
              disabled={loading}
            >
              {loading ? (
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              ) : (
                <IoSearch />
              )}
            </div>
          </Tooltip>
        </div>

        </div>
    </AnimatedHeaderSidHome>
  );
}

export default HeaderSideHom;
